// Browser time zone helpers shared by the profile and public pages.

export function browserTimeZone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || ""
  } catch (_error) {
    return ""
  }
}

// Wall clock of one instant in a zone, e.g. "12.11, 18:00".
export function wallClock(date, timeZone, withDate = false) {
  try {
    const options = { timeZone, hour: "2-digit", minute: "2-digit", hourCycle: "h23" }
    if (withDate) {
      options.day = "2-digit"
      options.month = "2-digit"
    }
    return new Intl.DateTimeFormat("ru-RU", options).format(date)
  } catch (_error) {
    return ""
  }
}

// True when two zones show the same clock right now (aliases, equal offsets).
export function sameOffset(zoneA, zoneB, now = new Date()) {
  if (!zoneA || !zoneB) return true
  if (zoneA === zoneB) return true
  const a = wallClock(now, zoneA, true)
  const b = wallClock(now, zoneB, true)
  return a !== "" && a === b
}
